import { Component, OnInit } from '@angular/core';
import {NavigatorService} from '../../services/navigatorService/navigator.service';
import {IResponse} from '../../interfaces/iresponse';
import {BootstrapNotifyService} from '../../services/bootstrap-notify/bootstrap-notify.service';
import {UserService} from '../../services/api-handlers/userService/user.service';
import {UtilService} from "../../services/utilService/util.service";
import {environment as ENV} from "../../../environments/environment";
// import '../../../assets/js/script';

@Component({
  selector: 'app-verify-password',
  templateUrl: './verify-password.component.html',
  styleUrls: ['./verify-password.component.css']
})
export class VerifyPasswordComponent implements OnInit {
  public CODE_VALIDATION: any =  ENV.CODE_VALIDATION;
  public credentials = {
    first_code: null,
    second_code: null,
    third_code: null,
    fourth_code: null,
    fifth_code: null,
    sixth_code: null
  };
  public userDetails: any;
  loaders = {
    loading: false
  };
  constructor(private notificationService: BootstrapNotifyService,
              private userService: UserService,
              private utilService: UtilService,
              private navigatorService: NavigatorService) {}
  ngOnInit(): void {
    this.userDetails = null;
    this.utilService.setFullPageBackgroundImage();
  }
  public verifyPassword() {
    if (!this.credentials.first_code || !this.credentials.second_code || !this.credentials.third_code || !this.credentials.fourth_code || !this.credentials.fifth_code || !this.credentials.sixth_code) {
      this.notificationService.info('You have to provide the code sent to your email to reset password!');
    } /*else if (!this.credentials.code.match(this.CODE_VALIDATION) ) {
      this.notificationService.info('Code Not Valid!!!');
    } */ else {
      this.loaders.loading = true;
      const VerifyPassword = {
        VerifyCode: this.credentials.first_code.toString() + this.credentials.second_code.toString() + this.credentials.third_code.toString() + this.credentials.fourth_code.toString() + this.credentials.fifth_code.toString() + this.credentials.sixth_code.toString()
      };
      console.log('Verify Code', VerifyPassword);
      this.userService.verifyPassword(VerifyPassword).subscribe((res: any) => {
        console.log('Response - code', VerifyPassword);
        this.loaders.loading = false;
        this.notificationService.success('Success!! Enter New Password on next Screen ');
        this.navigatorService.navigateUrl('/reset-password');
      }, error => {
        this.notificationService.error(error.error.message || 'Wrong Code Supplied');
        this.loaders.loading = false;
        console.info('Error => ', error);
      });
    }
  }

}
